import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCloseCrossSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <path
      d="M10.3333 10.3333L21.6667 21.6667M21.6667 10.3333L10.3333 21.6667"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
);
export default SvgCloseCrossSmall;
